'use strict';
import isNumber from 'lodash/isNumber';
import {intervalComparator, max} from './comparators';


/**
 * @param {Array<ActiveTimer#interval>} a
 * @param {Array<ActiveTimer#interval>} b
 * @return {Array<ActiveTimer#interval>}
 */
export function mergeIntervals(a, b) {
  const merged = [];

  const aEmpty = !a || a.length === 0;
  const bEmpty = !b || b.length === 0;

  if (aEmpty !== bEmpty) {
    return merged.concat(aEmpty ? b : a);

  } else if (aEmpty && bEmpty) {
    return merged;

  } else {
    // This is a Stack data structure
    const stack = [];
    const union = a.concat(b);
    union.sort(intervalComparator);
    stack.push(union[0]);

    for (let i = 1, n = union.length; i < n; i++) {
      const top = stackPeek(stack);
      const next = union[i];

      // if current interval is not overlapping with stack top,
      // push it to the stack
      const topId = top.id;
      const topStart = top.start;
      const topEnd = top.end;
      const nextId = next.id;
      const nextStart = next.start;
      const nextEnd = next.end;

      // TODO: not handling case of starts are equal correctly
      if (topStart === nextStart) {
        if (topId !== nextId || topEnd !== nextEnd) {
          const combinedNext = {
            ...top,
            end: max(topEnd, nextEnd),
            id: nextId ? nextId : topId,
          };

          stack.pop();
          stack.push(combinedNext);
        }

      } else if (!isNumber(topEnd)) {
        // merge top into next:
        // - remove top from the stack
        // - add next to the stack
        // - if top has an ID, add it to the delete list
        // - if next has an id, add it to the update list

        const combinedNext = {
          ...next,
          start: topStart,
        };

        stack.pop();
        stack.push(combinedNext);

      } else if (topEnd < nextStart) {
        stack.push(next);

        // Otherwise update the ending time of top if ending of current
        // interval is more
      } else if (!isNumber(nextEnd) || topEnd < nextEnd) {
        top.end = max(topEnd, nextEnd);

      }
    }

    return merged.concat(stack);
  }
}

/**
 * @param {Array<T>} stack
 * @return {T}
 * @template T
 */
function stackPeek(stack) {
  return stack[stack.length - 1];
}

/**
 * @param {ActiveTimer#intervals} intervals
 */
export function calcTotalTime(intervals) {
  return intervals.reduce((acc, interval) => acc + (interval.end ? interval.end - interval.start : 0), 0);
}



// WEBPACK FOOTER //
// ./src/js/timers/utils/intervalsUtils.js